import { createContext } from "react";

const SNACK_STATES = {
  normal: "normal",
  loading: "loading",
  success: "success",
};

const SNACK_POSITIONS = {
  topLeft: "topLeft",
  topRight: "topRight",
  bottomLeft: "bottomLeft",
  bottomRight: "bottomRight",
};

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
type SnackType = keyof typeof SNACK_STATES;
/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
type SnackPosition = keyof typeof SNACK_POSITIONS;

/**
 * @deprecated Use the `useSnackbar` hook from `@fullscript/aviary-web` instead
 */
interface LegacySnackbarData {
  isSnackbarOpen: boolean;
  message: string;
  status: string;
  position: SnackPosition;
  closeSnack: (message: string) => void;
  setSnackMessage: (status: SnackType, message: string, position?: SnackPosition) => void;
}

/**
 * @deprecated Use the `useSnackbar` hook from `@fullscript/aviary-web` instead
 */
const LegacySnackbarContext = createContext<LegacySnackbarData>(
  null as unknown as LegacySnackbarData
);

export type { LegacySnackbarData };
export { LegacySnackbarContext };

export type { SnackType, SnackPosition };
